/* @flow */
import React from 'react';
import { useUpdateQueryParams } from 'utils/location';

import Tr from 'components/UIKit/Table/Tr';

type TrLinkProps = {
  linkId: any,
  router: Object,
  children: any,
  style: Object,
  customDataTestID?: string,
}

const activeItemStyle = {
  backgroundColor: '#0950C3',
  color: '#fff',
  cursor: 'default',
};
const nonActiveItemStyle = {
  backgroundColor: 'transparent',
  color: '#222',
  cursor: 'pointer',
};

export default function TrLink({
  isActiveItem,
  children,
  linkId,
  router,
  style,
  customDataTestID,
}: TrLinkProps): React.Element {
  const newQuery = { did: linkId };
  const updateQueryParams = useUpdateQueryParams();

  return (
    <Tr
      customDataTestID={customDataTestID}
      className={isActiveItem ? 'selected' : ''}
      key={linkId}
      style={{ ...(isActiveItem ? activeItemStyle : nonActiveItemStyle), ...style }}
      onClick={() => !isActiveItem && updateQueryParams({ router }, newQuery)}
      >
      {children}
    </Tr>
  );
}
